import "./ConstructionBudgeting.module.css";
import Header from "@/reusable_sections/Header";
import CourseIntroduction from "./sections/CourseIntroduction";
import DetallesDelCurso from "./sections/DetallesDelCurso";
import CursosRelacionados from "./sections/CursosRelacionados";
import Footer from "@/reusable_sections/Footer";
export default function ConstructionBudgetingPage() {
  return <div>
      <Header />
      <CourseIntroduction />
      <DetallesDelCurso />
      <CursosRelacionados />
      <Footer />
    </div>;
}